import { z as e } from "zod";
const s = e.enum(["ok", "error"]), c = e.object({
  status: s
}).describe("Liveness check response"), a = e.object({
  status: s,
  checks: e.object({
    database: s.describe("Database connectivity status")
  })
}).describe("Readiness check response with dependency statuses"), n = e.string().describe("Health check message"), o = e.object({
  status: e.enum(["ok", "degraded", "error"]).describe("Overall app status"),
  version: e.string().optional().describe("Application version"),
  uptime: e.number().optional().describe("Uptime in seconds")
}).describe("Application status information");
export {
  o as AppStatusSchema,
  n as HealthResponseSchema,
  s as HealthStatusSchema,
  c as LivenessResponseSchema,
  a as ReadinessResponseSchema
};
//# sourceMappingURL=schemas.js.map
